import { render, staticRenderFns } from "./FallbackImage.vue?vue&type=template&id=425c648c"
import script from "./FallbackImage.vue?vue&type=script&lang=js"
export * from "./FallbackImage.vue?vue&type=script&lang=js"
import style0 from "./FallbackImage.vue?vue&type=style&index=0&id=425c648c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports